import * as Lucide from "lucide-react";

export const sidebarItems = [
  { name: "Settings", Icon: Lucide.Settings, href: "/settings" },
  { name: "Sources", Icon: Lucide.Blocks, href: "/settings/sources" },
  { name: "Account", Icon: Lucide.User, href: "/settings/account" },
];
